import React, { Component } from 'react';

class ContainerRight extends Component {
    constructor(props) {
        super(props);
        this.state = {
            collRight: [
                {
                    id: 1,
                    // subtitle: 'Chapter 7',
                    title: 'User-Friendly Platform',
                    text: 'Enjoy a seamless browsing and purchasing experience tailored to meet your convenience.'
                },
            ]
        }
    }
    render() {
        return (
            <div className="chapter-list border-right-0">
                {
                    this.state.collRight.map((data, i) => (
                        <div className="chapter-item" key={i}>
                            <h4><span>{data.subtitle} </span> {data.title}</h4>
                            <p>{data.text} </p>
                        </div>
                    ))
                }
            </div>
        );
    }
}

export default ContainerRight;
